import React, { memo } from 'react';
import { Box } from '@mui/material';
import { connect } from 'react-redux';
import PageDeal from '@pages/Pages/PageDeal';
import { useGetPageDeal } from '@hooks/useGetPageDeal';
import SiteSidebar from '@components/SiteSidebar';
import { sidebarStyle } from '@utils/theme';
import { AppState } from '@types';

type SubscribeAndSaveProps = ReturnType<typeof mapStateToProps>;

const SubscribeSaveNew = ({ dealPageSEO }: SubscribeAndSaveProps) => {
  const { data: pageDealData } = useGetPageDeal(
    'best-subscribe-save-deals-amazon'
  );

  const renderSidebar = () => {
    return <SiteSidebar slug="best-subscribe-save-deals-amazon" />;
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          '@media (max-width: 900px)': {
            display: 'block'
          }
        }}
      >
        <Box
          sx={{
            width: '62%',
            '@media (max-width: 1200px)': {
              width: '59%'
            },
            '@media (max-width: 900px)': {
              width: '100%'
            }
          }}
        >
          <PageDeal
            pageDealData={pageDealData}
            dealPageSEO={dealPageSEO}
            onDealsLoaded={() => {}}
            customTitle="BEST Subscribe & Save Deals"
          />
        </Box>
        <Box sx={sidebarStyle}>{renderSidebar()}</Box>
      </Box>
    </Box>
  );
};

const mapStateToProps = ({ home: { dealPageSEO } }: AppState) => ({
  dealPageSEO
});

export default connect(mapStateToProps)(memo(SubscribeSaveNew));
